import React from 'react';

import {
  DemoSelectControl,
  DemoToggleButtonGroupControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Output from './Output';
import Item from './Item';

function WrappingAlignItems({ withContent }) {
  const ref = React.useRef();

  const [containerWidth, setContainerWidth] = React.useState(600);

  const ControlType =
    withContent || containerWidth < 600
      ? DemoSelectControl
      : DemoToggleButtonGroupControl;

  React.useEffect(() => {
    function calculateSize() {
      if (!ref.current) {
        return;
      }

      if (document.documentElement.clientWidth < 700) {
        setContainerWidth(document.documentElement.clientWidth - 76);
      } else {
        setContainerWidth(600);
      }
    }

    calculateSize();

    window.addEventListener('resize', calculateSize);
    return () => {
      window.removeEventListener('resize', calculateSize);
    };
  }, []);

  const flexBasis = Math.floor(containerWidth / 2);

  return (
    <FlexDemo
      centered
      initialValues={{
        '--wrap': 'wrap',
        '--align-items': 'flex-start',
        '--align-content': 'flex-start',
      }}
      customGrid={{
        gridTemplateColumns: withContent ? '1fr 1fr' : '1fr',
      }}
      controls={[
        <ControlType
          key="--align-items"
          id="--align-items"
          label="align-items"
          options={['flex-start', 'center', 'flex-end', 'stretch']}
          wrapperStyle={{
            width: withContent ? 284 : containerWidth,
          }}
        />,
        withContent && (
          <ControlType
            isNew
            key="--align-content"
            id="--align-content"
            label="align-content"
            options={[
              'flex-start',
              'center',
              'flex-end',
              'stretch',
              'space-between',
              'space-around',
              'space-evenly',
            ]}
            wrapperStyle={{
              width: 284,
            }}
          />
        ),
      ]}
    >
      {(state) => {
        return (
          <Output
            ref={ref}
            state={state}
            height="280px"
            wrapperStyle={{
              width: containerWidth + 12,
            }}
          >
            <Item style={{ flexBasis, minHeight: 0 }} />
            <Item style={{ flexBasis, minHeight: 100 }} />
            <Item style={{ flexBasis, minHeight: 100 }} />
            <Item style={{ flexBasis, minHeight: 35 }} />
          </Output>
        );
      }}
    </FlexDemo>
  );
}

export default WrappingAlignItems;
